export const ADD_TO_CART = 'addtoCart';
export const ADD_TO_CART_ERROR = 'addtoCartError';
export const REMOVE_FROM_CART = 'removeFromCart';
export const REMOVE_FROM_CART_ERROR = 'removeFromCartError';
export const CART_RESET ="cartReset";